import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';

import { useQuery, useQueryClient } from "react-query";
import { fetchMontantMiniRetourExclus } from 'utils/queries';

import { deleteMontantMiniRetourExclu, postMontantMiniRetourExclu } from 'utils/posters';
import AddMontantMiniRetourExcluDialog from './AddMontantMiniRetourExcluDialog';
import DeleteMontantMiniRetourExcluDialog from './DeleteMontantMiniRetourExcluDialog';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { green } from '@mui/material/colors';

const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },
    table: {
        //minWidth: 700
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    link: theme.style.link,
    administrationHeaderContainer: {
        display: 'flex',
        width: '100%'
    },
    administrationHeaderItemLeft: {
        flex: '1 1 auto'
    },
    administrationHeaderItemRight: {
        flex: '0 1 auto'
    },
    deleting: {
        background: 'red'
    },
    nowrapCell: {
        whiteSpace: 'nowrap'
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse',
        marginBottom: theme.spacing(3)
    }
});

const AdministrationMontantMiniRetourExclus = ({
    classes,
    deleteMontantMiniRetourExclu,
    postMontantMiniRetourExclu }) => {

    const queryClient = useQueryClient();

    /** Hook niveaux */
    const [niveaux, setNiveaux] = React.useState([]);

    /** Hook montantMiniRetourExclus */
    const [montantMiniRetourExclus, setMontantMiniRetourExclus] = React.useState([]);

    /** Hook loading */
    const [loading, setLoading] = React.useState(false);

    /** Hook modale suppression sélection */
    const [dialogDeleteMontantMini, setDialogDeleteMontantMini] = React.useState({
        isOpen: false
    });

    /** Hook modale ajout montant mini */
    const [dialogAddMontantMini, setDialogAddMontantMini] = React.useState({
        isOpen: false
    });

    /** Hook ligne montant sélectionnée */
    const [selectedMontantMini, setSelectedMontantMini] = React.useState(null);

    /** Handler d'ouverture de la modale suppression d'un montant mini */
    const handleOpenDialogDeleteMontantMini = (selectedMontantMini) => {
        setSelectedMontantMini(selectedMontantMini);
        setDialogDeleteMontantMini({ isOpen: true });
    }

    /** Handler d'ouverture de la modale ajout d'un montant mini */
    const handleOpenDialogAddMontantMini = () => {
        setDialogAddMontantMini({ isOpen: true });
    }

    /** Handler de fermeture de la modale de suppression d'un montant mini */
    const onCloseDeleteDialog = () => {
        setDialogDeleteMontantMini({ isOpen: false });
        setSelectedMontantMini(null)
    }

    /** Handler de fermeture de la modale d'ajout d'un montant mini */
    const onCloseAddDialog = () => {
        setDialogAddMontantMini({ isOpen: false });
    }

    /** Handler de suppression d'un montant mini */
    const handlerDeleteMontantMiniRetourExclu = async (montantMini, niveau) => {
        let response = await deleteMontantMiniRetourExclu(montantMini, niveau);

        if (response) {
            queryClient.refetchQueries("MontantMiniRetourExclus");
        }
    }

    /** Handler d'ajout d'un montant mini */
    const handlerAddMontantMiniRetourExclu = async (code, niveau) => {
        let response = await postMontantMiniRetourExclu(code, niveau);

        if (response && response.status === 200) {
            queryClient.refetchQueries("MontantMiniRetourExclus");
        }
    }

    /** On récupère les montants mini retour exclus */
    const query = useQuery("MontantMiniRetourExclus", () => fetchMontantMiniRetourExclus());

    React.useEffect(() => {
        if (!query.isLoading && !query.error && query.data) {
            setNiveaux(query.data.niveaux);
            setLoading(query.data.isLoading);
            setMontantMiniRetourExclus(query.data.items);
        }
    }, [montantMiniRetourExclus, niveaux, loading, query]);

    return (
        <>
            {niveaux &&
                <AddMontantMiniRetourExcluDialog
                    niveaux={niveaux}
                    onClose={onCloseAddDialog}
                    onClickSave={handlerAddMontantMiniRetourExclu}
                    open={dialogAddMontantMini.isOpen}
                />
            }

            {selectedMontantMini && niveaux &&
                <DeleteMontantMiniRetourExcluDialog
                    open={dialogDeleteMontantMini.isOpen}
                    niveaux={niveaux}
                    onClose={onCloseDeleteDialog}
                    onClickDelete={handlerDeleteMontantMiniRetourExclu}
                    montantMiniRetourExclu={selectedMontantMini}
                />
            }

            <Card className={classNames(classes.paper)}>
                <div className={classes.administrationHeaderContainer}>
                    <Typography gutterBottom variant="h5" className={classes.administrationHeaderItemLeft}>
                        Administration des exclusions pour les montants minimum au retour
                    </Typography>

                    <Button className={classes.administrationHeaderItemRight} onClick={handleOpenDialogAddMontantMini}>
                        Nouveau
                    </Button>
                </div>

                <Paper className={classes.root}>
                    <Table className={classes.table} size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell>Niveau</TableCell>
                                <TableCell>Code</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {montantMiniRetourExclus.map(montantMiniRetourExclu => {
                                let niveau = niveaux.find(n => n.id === montantMiniRetourExclu.niveau);
                                return (
                                    <TableRow key={montantMiniRetourExclu.id}
                                        className={selectedMontantMini && selectedMontantMini.id === montantMiniRetourExclu.id ? classes.deleting : ''}
                                        hover
                                    >
                                        <TableCell>{niveau.libelle}</TableCell>
                                        <TableCell>{montantMiniRetourExclu.code}</TableCell>
                                        <TableCell>
                                            <Button onClick={() => handleOpenDialogDeleteMontantMini(montantMiniRetourExclu)}>
                                                Supprimer
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Paper>
            </Card>
        </>
    );
}

const mapDispatchToProps = {
    postMontantMiniRetourExclu,
    deleteMontantMiniRetourExclu
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(AdministrationMontantMiniRetourExclus));